import axios from 'axios';
import http from "@/utils/http-common"
// import { setRefreshLock, clearRefreshLock, isAnotherTabRefreshing } from '@/utils/tokenRefreshLock';
import { setRefreshLock, clearRefreshLock } from '@/utils/tokenRefreshLock';
import { createTokenChannel } from '@/utils/tokenChannel';
import store from "@/store";
import { jwtDecode } from "jwt-decode";
import { getRefreshTokenConfig, isCookieRefreshEnabled } from "@/utils/auth-tokens";

function isAccessTokenExpired() {
  if (!store.state.access_token && !store.state.id_token) { // 로그인 이전 상황 - 토큰 갱신 프로세스가 돌지 않아야하기 때문에 토큰 만료되지 않음 처리
    const hasPersistedUser = Object.keys(store.state.user_info || {}).length > 0
    console.log('isAccessTokenExpired 1', isCookieRefreshEnabled(store.state.auth_refresh_mode) && hasPersistedUser, '토큰 없음 - cookie 모드에서 사용자 정보가 있으면 refresh 필요')
    return isCookieRefreshEnabled(store.state.auth_refresh_mode) && hasPersistedUser
  }

  try {
    if (store.state.user_info.user_type) {
      let userType = store.state.user_info.user_type
      let exp = null
      if (userType === 'google') {
        if (!store.state.id_token) { // user_info는 있는데 id_token이 없는 상황 - 로직 변경 전에 로그인하였거나 jwtDecode를 실행할 id_token이 없기 때문에 토큰 만료 처리하여 토큰 갱신 실행
          console.log('isAccessTokenExpired 2', true, 'user_info는 있는데 id_token이 없는 상황 - 로직 변경 전에 로그인하였거나 jwtDecode를 실행할 id_token이 없기 때문에 토큰 만료 처리하여 토큰 갱신 실행')
          return true
        }
        exp = jwtDecode(store.state.id_token).exp
      }
      else if (userType === 'django') {
        if (!store.state.access_token) { // user_info는 있는데 id_token이 없는 상황 - 에러 상황이기 때문에 토큰 갱신 실행할 수 없으므로 토큰 만료되지 않음 처리
          console.log('isAccessTokenExpired 3', false, 'user_info는 있는데 id_token이 없는 상황 - 에러 상황이기 때문에 토큰 갱신 실행할 수 없으므로 토큰 만료되지 않음 처리')
          return false
        }
        exp = jwtDecode(store.state.access_token).exp
      }
      console.log(`${userType} exp`, exp) // 초(s) 단위
      const date_now = Date.now() / 1000 // 밀리초(ms) -> 초(s) 변환
      console.log(`${userType} date_now`, date_now)
      const bufferTime = 5 * 60 // 5분(300초) 여유시간
      console.log(`${userType} bufferTime`, bufferTime)
      console.log(`${userType} date_now + bufferTime`, date_now + bufferTime)
      console.log(`${userType} (date_now + bufferTime) - exp`, date_now + bufferTime - exp) // 양수(true): 만료예상시간(exp)이 넘어서 토큰 만료처리 후 토큰 갱신, 음수(false): 만료예상시간(exp)이 넘지 않아어서 토큰 만료되지 않음 처리
      console.log('isAccessTokenExpired 4', date_now + bufferTime > exp, '양수(true): 만료예상시간(exp)이 넘어서 토큰 만료처리 후 토큰 갱신, 음수(false): 만료예상시간(exp)이 넘지 않아어서 토큰 만료되지 않음 처리')
      return date_now + bufferTime > exp
    }
    else { // 예외 상황이기 때문에 토큰 갱신 실행할 수 없으므로 토큰 만료되지 않음 처리
      console.log('isAccessTokenExpired 5', false, '예외 상황이기 때문에 토큰 갱신 실행할 수 없으므로 토큰 만료되지 않음 처리')
      return false
    }
  } catch { // 예외 상황이기 때문에 토큰 갱신 실행할 수 없으므로 토큰 만료되지 않음 처리
    console.log('isAccessTokenExpired 6', false, '예외 상황이기 때문에 토큰 갱신 실행할 수 없으므로 토큰 만료되지 않음 처리')
    return false
  }
}

const TokenManager = {
  install(Vue, { store, refreshInterval = 1000 * 60 * 1 }) {
    console.log('TokenManager install')

    const channel = createTokenChannel((token) => {
      store.commit('setAccessToken', token);
    });

    // axios.interceptors.request.use(async (config) => {
    //   console.log('TokenManager interceptors')
    //   if (isAccessTokenExpired()) {
    //     console.log('TokenManager interceptors - isAccessTokenExpired()')
    //     if (isAnotherTabRefreshing()) {
    //       await waitForTokenFromOtherTab(store);
    //     } else {
    //       await refreshToken(store, channel);
    //     }
    //   }
    //   config.headers.Authorization = `Bearer ${store.state.access_token}`;
    //   return config;
    // });

    if (isAccessTokenExpired()) {
      console.log('TokenManager install - isAccessTokenExpired() === true')
      refreshToken(store, channel).catch(() => {});
    }
    setInterval(() => {
      console.log('TokenManager refreshInterval')
      if (isAccessTokenExpired()) {
        console.log('TokenManager refreshInterval - isAccessTokenExpired() === true')
        refreshToken(store, channel).catch(() => {});
      }
    }, refreshInterval);

    // axios.interceptors.request.use(async (config) => {
    //   console.log('TokenManager interceptors - store.getters.isAccessTokenExpired()', store.getters.isAccessTokenExpired())
    //   if (store.getters.isAccessTokenExpired() === true) {
    //     if (isAnotherTabRefreshing()) {
    //       await waitForTokenFromOtherTab(store);
    //     } else {
    //       await refreshToken(store, channel);
    //     }
    //   }
    //   config.headers.Authorization = `Bearer ${store.state.access_token}`;
    //   return config;
    // });

    // console.log('TokenManager init - store.getters.isAccessTokenExpired()', store.getters.isAccessTokenExpired())
    // if (store.getters.isAccessTokenExpired() === true) {
    //   refreshToken(store, channel).catch(() => {});
    // }
    // setInterval(() => {
    //   console.log('TokenManager refreshInterval - store.getters.isAccessTokenExpired()', store.getters.isAccessTokenExpired())
    //   if (store.getters.isAccessTokenExpired() === true) {
    //     refreshToken(store, channel).catch(() => {});
    //   }
    // }, refreshInterval);
  }
};

function refreshToken(store, channel) {
  return new Promise((resolve, reject) => {
    console.log('TokenManager > refreshToken')
    setRefreshLock();
    let userType = ''
    if (store.state.user_info) userType = store.state.user_info.user_type;
    console.log('TokenManager > refreshToken - userType', userType)
    if (userType === 'google') {
      console.log('TokenManager > refreshToken - userType === google')
      axios.post('https://oauth2.googleapis.com/token', {
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET,
        refresh_token: store.state.refresh_token,
        grant_type: 'refresh_token',
      })
      .then(googleTokenRes => {
        console.log('TokenManager > refreshToken - googleTokenRes', googleTokenRes)
        let newAccessToken = googleTokenRes.data.access_token;
        console.log('TokenManager > refreshToken - newAccessToken', newAccessToken)
        if (newAccessToken) {
          console.log('TokenManager > refreshToken - setAccessToken')
          store.commit('setAccessToken', newAccessToken);
          channel.postMessage({ type: 'NEW_ACCESS_TOKEN', token: newAccessToken });
          http
          .get('account/update-token/', { headers: { Authorization: 'Bearer ' + newAccessToken } }) // BE에 새로 갱신한 access token 정보 저장
          .then((res1) => {
            console.log(res1);
            console.log('BE에 새로 갱신한 access token 정보 저장');
            store.commit('setAccessToken', newAccessToken); // store에 새로 갱신한 access token 저장
            store.commit('setIdToken', googleTokenRes.data.id_token); // store에 새로 갱신한 id token 저장
            resolve('access token 갱신 및 저장 완료');
          })
          .catch((err1) => {
            console.log('BE에 access token 저장 실패');
            console.log(err1);
            console.log(err1.response);
            reject('BE에 access token 저장 실패')
          });
        } else {
          reject('No new access token received')
        }
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        reject(err)
      })
      .finally(() => {
        clearRefreshLock();
      })
    }
    else if (userType === 'django' || userType === 'django-prosecution') {
      console.log('TokenManager > refreshToken - userType === django')
      http.get('account/update-token-recolumn/', getRefreshTokenConfig(store.state.refresh_token, store.state.auth_refresh_mode))
      .then(djangoTokenRes => {
        console.log('TokenManager > refreshToken - djangoTokenRes', djangoTokenRes)
        // store.commit('setRefreshToken', djangoTokenRes.data.refresh_token);
        let newToken = null;
        newToken = djangoTokenRes.data.access_token;
        console.log('TokenManager > refreshToken - newToken')
        if (newToken) {
          console.log('TokenManager > refreshToken - setAccessToken')
          store.commit('setAccessToken', newToken);
          channel.postMessage({ type: 'NEW_ACCESS_TOKEN', token: newToken });
          resolve('access token 갱신 및 저장 완료')
        } else {
          reject('No new access token received')
        }
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        reject(err)
      })
      .finally(() => {
        clearRefreshLock();
      })
    }
  });
}

// async function refreshToken(store, channel) {
//   console.log('TokenManager refreshToken')
//   setRefreshLock();
//   try {
//     let userType = ''
//     if (store.state.user_info) userType = store.state.user_info.user_type;
//     console.log('TokenManager userType', userType)
    
//     if (userType === 'google') {
//       console.log('TokenManager userType === google')
//       let googleTokenRes = await axios.post('https://oauth2.googleapis.com/token', {
//         client_id: process.env.VUE_APP_CLIENT_ID,
//         client_secret: process.env.VUE_APP_CLIENT_SECRET,
//         refresh_token: store.state.refresh_token,
//         grant_type: 'refresh_token',
//       });
//       console.log('TokenManager googleTokenRes', googleTokenRes)
//       let newToken = null;
//       newToken = googleTokenRes.data.access_token;
//       console.log('TokenManager newToken')
//       if (newToken) {
//         console.log('TokenManager setAccessToken')
//         store.commit('setAccessToken', newToken);
//         channel.postMessage({ type: 'NEW_ACCESS_TOKEN', token: newToken });
//       } else {
//         throw new Error('No new access token received');
//       }
//     }
//     else if (userType === 'django') {
//       console.log('TokenManager userType === django')
//       let djangoTokenRes = await http.get('account/update-token-recolumn/', getRefreshTokenConfig(store.state.refresh_token, store.state.auth_refresh_mode));
//       console.log('TokenManager djangoTokenRes', djangoTokenRes)
//       store.commit('setRefreshToken', djangoTokenRes.data.refresh_token);
//       let newToken = null;
//       newToken = djangoTokenRes.data.access_token;
//       console.log('TokenManager newToken')
//       if (newToken) {
//         console.log('TokenManager setAccessToken')
//         store.commit('setAccessToken', newToken);
//         channel.postMessage({ type: 'NEW_ACCESS_TOKEN', token: newToken });
//       } else {
//         throw new Error('No new access token received');
//       }
//     }
//   } catch (err) {
//     console.log('TokenManager refreshToken err', err)
//     console.log('TokenManager refreshToken err.response', err.response)

//     // console.log('refresh token 만료(access token 갱신 실패)')
//     // store.commit('logout')
//     // router.push('/').catch(() => {})
//   } finally {
//     clearRefreshLock();
//   }
// }

// function waitForTokenFromOtherTab(store) {
//   return new Promise((resolve, reject) => {
//     const timeout = setTimeout(() => reject(new Error('Timeout waiting for token')), 10000);
//     const channel = new BroadcastChannel('auth_channel');
//     const listener = (event) => {
//       if (event.data.type === 'NEW_ACCESS_TOKEN') {
//         clearTimeout(timeout);
//         store.commit('setAccessToken', event.data.token);
//         channel.removeEventListener('message', listener);
//         resolve();
//       }
//     };
//     channel.addEventListener('message', listener);
//   });
// }

export default TokenManager;
